import { posthog } from "posthog-js"
import { PostHogProvider } from "posthog-js/react"
import { type FC, type PropsWithChildren, useEffect } from "react"
import { Analytics } from "@/analytics"

export const AnalyticsProvider: FC<PropsWithChildren> = ({ children }) => {
  // Init posthog when app is ready/mounted
  useEffect(() => {
    Analytics.initialize()
  }, [])

  if (!Analytics.isEnabled()) return <>{children}</>

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}
